import React from "react";
import { ImageSlider, Service, TreatmentHistory, DoctorsSection, DentalSpecialities, DentalImplants, LocationSection } from "../../SecondComponents";


const SecondHome = (props) => {
    return (
        <div>
            <ImageSlider {...props}/>
            <Service {...props} />
            <TreatmentHistory {...props}/>
            <DoctorsSection {...props}/>
            <DentalSpecialities {...props}/>
            <DentalImplants {...props}/>
            <LocationSection {...props}/>
        </div>
    )
}

export default SecondHome